import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Link} from 'shells/link/link';

type Props = {
    htmlUrlPath: string;
    text: string;
};

export function SmsEditionActionElement(props: Props) {
    return (
        <div className='flex' style={{minWidth: 'fit-content'}}>
            {/* @ts-expect-error */}
            <Link variant='primary' to={`${props.htmlUrlPath}/details`} as={RoutedLink}>
                {props.text}
            </Link>
        </div>
    );
}
